<template>
  <div class="amountList table-hook fadeInRight">
    <div class="title-box">
      <h3>档位列表 - {{ seriesName }}</h3>
      <el-form
        inline
        class="hook right themed-form search-form"
        style="line-height: 40px"
      >
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="themed-button"
            @click="addAmount"
            >分配档位</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-back"
            class="themed-button"
            @click="goBack"
            >返回</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="content-box">
      <el-table
        ref="table"
        :data="tableData"
        stripe
        border
        :max-height="maxTableHeight"
      >
        <el-table-column
          label="预存系列名称"
          prop="seriesName"
          width="150px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="充值金额"
          prop="rechargeAmount"
          width="150px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="赠送金额"
          prop="sendMoney"
          width="150px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="创建时间"
          prop="createTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" width="150px">
          <template slot-scope="scope">
            <el-button
              type="danger"
              class="themed-button"
              @click="removeAmount(scope.row)"
              >移除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <!-- 分配档位对话框 -->
    <el-dialog title="档位列表" :visible.sync="dialogVisible" width="65%" append-to-body>
      <el-form :model="amountForm" ref="amountForm" :inline="true" label-width="68px" class="dialogAmountTable">
        <el-form-item label="代理商" prop="agentName" size="mini">
          <el-select v-model="amountForm.agentName" @change="agentChange" filterable placeholder="请选择代理商">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item,index) in agentList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item size="mini" class="button">
          <el-button type="primary" icon="el-icon-search"   class="themed-button"   @click="handleQueryAmount">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table v-loading="loading" :highlight-current-row="true" :data="amountTableData" @selection-change="handleSelectionAmountChange" style="max-height:580px;overflow-y:auto">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column label="充值金额" prop="rechargeAmount" width="150px" show-overflow-tooltip></el-table-column>
        <el-table-column label="赠送金额" prop="sendMoney" width="150px" show-overflow-tooltip></el-table-column>
        <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip></el-table-column>
        <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleAmountSizeChange"
          @current-change="handleAmountCurrentChange"
          :current-page="amountForm.pageNo"
          :page-sizes="[5, 10, 15, 50,100,1000]"
          :page-size="amountForm.pageSize"
          background
          :total="amountTotal">
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmSelectedAmount"  class="themed-button">确 定</el-button>
        <el-button @click="cancelSelectedAmount" class="themed-button"
        type="info" >取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import {
  getAmountList,
  assignAmount,
  removeAmount,
} from "@/api/networkCardBalanceManagement/preArchiveSeries.js";
import { amountList, agentList } from "@/api/cardManagement/proAgentAmount.js";
import { orderGetAgents } from "@/api/agentApplyCheck.js";
import resize from "@/mixins/resize.js";

export default {
  name: "amountList",
  mixins: [resize],
  data() {
    return {
      seriesId: "",
      seriesName: "",
      tableData: [],
      dialogVisible: false,
      loading: false,
      amountTableData: [],
      amountForm: {
        agentName: "",
        pageSize: 15,
        pageNo: 1
      },
      amountTotal: 0,
      selectedAmountIds: [],
      agentList: [],
    };
  },
  mounted() {
    this.seriesId = this.$route.params.seriesId;
    this.getAmountList();
    this._orderGetAgents();
  },
  methods: {
    getAmountList() {
      let params = {
        seriesId: this.seriesId,
      };
      getAmountList(params).then((res) => {
        this.tableData = res;
        if (res.length > 0) {
          this.seriesName = res[0].seriesName || "未知系列";
        }
      });
    },
    
    addAmount() {
      this.loading = true;
      this.showAmountDialog();
    },
    
    _amountList() {
      let params = {
        pageSize: this.amountForm.pageSize,
        pageNo: this.amountForm.pageNo,
      };
      Object.assign(params, { importType: 2 });
      
      if (this.amountForm.agentName) {
        Object.assign(params, { agentName: this.amountForm.agentName });
      }

      amountList(params).then((res) => {
        this.loading = false;
        this.amountForm.pageNo = res.pageNo;
        this.amountForm.pageSize = res.pageSize;
        this.amountTotal = res.total;
        this.amountTableData = res.rows;
      }).catch(() => {
        this.loading = false;
        this.dialogVisible = false;
      });
    },

    handleAmountSizeChange(val) {
      this.amountForm.pageSize = val;
      this._amountList();
    },

    handleAmountCurrentChange(val) {
      this.amountForm.pageNo = val;
      this._amountList();
    },

    handleSelectionAmountChange(selection) {
      this.selectedAmountIds = selection.map(item => item.id);
    },

    handleQueryAmount() {
      this.amountForm.pageNo = 1;
      this._amountList();
    },

    showAmountDialog() {
      this.dialogVisible = true;
      // 初始化档位选择对话框
      this.amountForm = {
        agentName: "",
        pageSize: 15,
        pageNo: 1
      };
      this._amountList();
    },

    confirmSelectedAmount() {
      if (!this.selectedAmountIds || this.selectedAmountIds.length == 0) {
        this.$alert('请选择一条数据', '提示', {
          confirmButtonText: '确定',
        });
        return false;
      }
      
      // 将选中的档位ID数组转换为逗号隔开的字符串
      let amountIds = this.selectedAmountIds.join(',');
      
      let params = {
        seriesId: this.seriesId,
        amountIds: amountIds,
      };
      
      // 调用批量分配档位的API
      assignAmount(params).then(() => {
        this.getAmountList();
        this.dialogVisible = false;
        this.selectedAmountIds = [];
        this.$message({
          showClose: true,
          message: '分配成功',
          type: 'success',
        });
      }).catch(() => {
        this.selectedAmountIds = [];
        this.dialogVisible = false;
        this.$message({
          showClose: true,
          message: '分配失败',
          type: 'error',
        });
      });
    },

    cancelSelectedAmount() {
      this.selectedAmountIds = [];
      this.dialogVisible = false;
    },

    agentChange(val) {
      this.amountForm.agentName = val;
      this.handleQueryAmount();
    },

    _orderGetAgents() {
      this.agentList = [];
      orderGetAgents({ status: 0 }).then((res) => {
        if (res.length > 0) {
          res.forEach((item) => {
            this.agentList.push({
              label: item.name,
              value: item.id
            });
          });
        }
      });
    },
    
    removeAmount(row) {
      this.$confirm("确认要移除该档位吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: row.id,
          };
          removeAmount(params)
            .then((res) => {
              this.getAmountList();
              this.$message({
                showClose: true,
                message: "移除成功",
                type: "success",
              });
            })
            .catch(() => {
              this.$message({
                showClose: true,
                message: "移除失败",
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.amountList {
  padding: 20px;
}

.title-box {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-box h3 {
  margin: 0;
}

.content-box {
  margin-bottom: 20px;
}

.dialogAmountTable .button {
  margin-left: 10px;
}
</style>
